import { styled } from "@mui/material/styles";
import { PopupBody as PopupBodyComponent } from "../popup-body";

export const DateInputContainer = styled("div", {
  label: "date-input-container",
})`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  column-gap: ${({ theme }) => theme.spacing(2.25)};
  padding-top: ${({ theme }) => theme.spacing(1.5)};
  min-height: ${({ theme }) => theme.spacing(9)};

  & p {
    margin-top: 0;
  }
`;

export const PopupBody = styled(PopupBodyComponent, {
  label: "popup-body",
})`
  ${({ theme }) => theme.breakpoints.up("sm")} {
    max-width: ${({ theme }) => theme.spacing(60)};
  }
`;

export const SubTitle = styled("p", {
  label: "sub-title",
})`
  font-weight: 600;
`;
